import { render, staticRenderFns } from "./m-page.vue?vue&type=template&id=71c0259a&scoped=true"
import script from "./m-page.vue?vue&type=script&lang=js"
export * from "./m-page.vue?vue&type=script&lang=js"
import style0 from "./m-page.vue?vue&type=style&index=0&id=71c0259a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c0259a",
  null
  
)

export default component.exports